<div class="container" id="print-section">

  <!-- ============ LEDGER TABLE (FROM API) ============ -->
  <table style="width:100%;border:2px solid #000;border-collapse:collapse;text-align:center;">

    <!-- HEADER -->
    <tr>
     <td colspan="4"
    style="border:2px solid #000;font-weight:bold;font-size:18px;">
  {{ category }}
</td>
    </tr>

    <tr>
      <td colspan="4" style="border:2px solid #000;text-align:left;">
        दिनांक : {{ today | date:'dd-MM-yyyy' }}
      </td>
    </tr>

    <!-- COLUMN HEADERS -->
    <tr style="font-weight:bold;">
      <td style="border:2px solid #000;">नाव</td>
      <td style="border:2px solid #000;">छपाई</td>
      <td style="border:2px solid #000;">जमा</td>
      <td style="border:2px solid #000;">एकूण</td>
    </tr>

    <!-- LOADING STATE -->
    <tr *ngIf="loading" class="noPrint">
      <td colspan="4" style="border:2px solid #000;">डेटा लोड होत आहे...</td>
    </tr>

    <!-- OFFICE REPRESENTATIVE ROWS ONLY (rep-level rows removed) -->
    <tr *ngFor="let office of officeGroups" style="font-weight:bold;">
      <td style="border:2px solid #000;text-align:left;">
        {{ office.office_rep_name || 'अनिर्दिष्ट' }}
      </td>
      <td style="border:2px solid #000;">{{ office.totalBookCopies }}</td>
      <td style="border:2px solid #000;">{{ office.totalReceived }}</td>
      <td style="border:2px solid #000;">{{ office.totalAmount }}</td>
    </tr>

    <!-- GRAND TOTAL ROW -->
    <tr style="font-weight:bold;background:#e0e0e0;">
      <td style="border:2px solid #000;">एकूण बेरीज</td>
      <td style="border:2px solid #000;">{{ grandSummary.totalBookCopies }}</td>
      <td style="border:2px solid #000;">{{ grandSummary.totalReceived }}</td>
      <td style="border:2px solid #000;">{{ grandSummary.totalAmount }}</td>
    </tr>

  </table>

  <br>

  <!-- ============ ALLOCATION TABLE (MANUAL - नोंदणी वाटप) ============ -->
<!-- ============ ALLOCATION TABLE (MANUAL - नोंदणी वाटप) ============ -->
<table style="width:60%;border:2px solid #000;border-collapse:collapse;text-align:center;">

  <tr>
    <td colspan="3" style="border:2px solid #000;font-weight:bold;">
      नोंदणी वाटप
    </td>
  </tr>

  <!-- COLUMN HEADERS -->
  <tr style="font-weight:bold;">
    <td style="border:2px solid #000;">नाव</td>
    <td style="border:2px solid #000;">रक्कम</td>
    <td class="noPrint" style="border:2px solid #000;">-</td>
  </tr>

  <!-- ROWS (now pre-filled: नोंदणी, जाहिरात, साहित्य, संपादकीय, प्रकाशन, कार्यालय) -->
  <tr *ngFor="let a of allocationRows; let i = index">
    <td style="border:2px solid #000;text-align:left;">
      <input type="text"
             [(ngModel)]="a.name"
             style="width:100%;border:none;text-align:left;">
    </td>
    <td style="border:2px solid #000;">
      <input type="number"
             [(ngModel)]="a.amount"
             (input)="onAllocationChange()"
             style="width:100%;border:none;text-align:center;">
    </td>
    <td class="noPrint" style="border:2px solid #000;">
      <button (click)="removeAllocationRow(i)"
              style="background:#d32f2f;color:#fff;border:none;padding:2px 8px;border-radius:4px;">
        ×
      </button>
    </td>
  </tr>

  <!-- TOTAL ROW -->
  <tr style="font-weight:bold;">
    <td style="border:2px solid #000;">एकूण</td>
    <td style="border:2px solid #000;">{{ totalAllocation }}</td>
    <td class="noPrint" style="border:2px solid #000;"></td>
  </tr>

  <!-- ADD ROW -->
  <tr class="noPrint">
    <td colspan="3" style="border:2px solid #000;">
      <button (click)="addAllocationRow()"
              style="background:#1976d2;color:#fff;border:none;padding:5px 10px;border-radius:4px;">
        + नवीन ओळ
      </button>
    </td>
  </tr>

</table>

</div>

<!-- ACTION BUTTONS -->
<div style="margin-left:70%;margin-bottom:2%;" class="noPrint">

  <button mat-raised-button color="warn" (click)="exportexcel('Print_Order')">
    Export
  </button>

  <button mat-raised-button color="primary" printSectionId="print-section" ngxPrint>
    Print
  </button>

  <button mat-raised-button color="primary" (click)="save()">
    Save
  </button>

  <button class="btn" (click)="closeDialog()">
    Close
  </button>

</div>